<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-eye mr-2"></i>{{Core.Definition.getDefinition('Général')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="general"
                        @onRequestSuccess="onRequestSuccess"
                        getRoot="/setting/appearance-general"
                        saveRoot="/setting/appearance-general"
                        :formStructure="dataFormStructures.general">
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-lock mr-2"></i>{{Core.Definition.getDefinition('Connexion')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="login"
                        @onRequestSuccess="onRequestSuccess"
                        getRoot="/setting/appearance-login"
                        saveRoot="/setting/appearance-login"
                        :formStructure="dataFormStructures.login">
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-calendar mr-2"></i>{{Core.Definition.getDefinition('Événement')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="event"
                        @onRequestSuccess="onRequestSuccess"
                        getRoot="/setting/appearance-event"
                        saveRoot="/setting/appearance-event"
                        :formStructure="dataFormStructures.event">
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    import Request from '../../../components/Request'
    export default {
        name: 'SettingsAppearance',
        components: {
            DynamicForm,
            Request
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataFormStructures: {
                    event: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Informations visibles aux utilisateurs'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayMessage'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayParticipant'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayResponsable'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayDescription'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayMinMax'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'displayLocal'
                                                                    }
                                                                ]
                                                            },
                                                            {},{}
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },{}
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'displayMessage',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Messages')
                            },
                            {
                                id: 'displayParticipant',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Participants')
                            },
                            {
                                id: 'displayResponsable',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Responsable')
                            },
                            {
                                id: 'displayDescription',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Description')
                            },
                            {
                                id: 'displayMinMax',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Min / Max')
                            },
                            {
                                id: 'displayLocal',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Local')
                            }
                        ]
                    },
                    general: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Image de marque'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoFull'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoFullWidth'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoMinimized'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoFavicon'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Chargement'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoLoading'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoLoadingWidth'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoLoadingAnimationClass'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'logoFull',
                                type: 'avatar',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                },
                                label: Core.Definition.getDefinition('Logo principal')
                            },
                            {
                                id: 'logoMinimized',
                                type: 'avatar',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                },
                                label: Core.Definition.getDefinition('Logo réduit'),
                                description: Core.Definition.getDefinition('Si vide, le logo principal sera utilisé.')
                            },
                            {
                                id: 'logoFavicon',
                                type: 'avatar',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                },
                                label: Core.Definition.getDefinition('Logo Favicon')
                            },
                            {
                                id: 'logoLoading',
                                type: 'avatar',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                },
                                label: Core.Definition.getDefinition('Logo de chargement'),
                                description: Core.Definition.getDefinition('Si vide, le logo principal sera utilisé.')
                            },
                            {
                                id: 'logoFullWidth',
                                type: 'text',
                                label: Core.Definition.getDefinition('Largeur du logo principal'),
                                description: Core.Definition.getDefinition('EX: 100px ou 40%'),
                                value: ''
                            },
                            {
                                id: 'logoLoadingWidth',
                                type: 'text',
                                label: Core.Definition.getDefinition('Largeur du logo chargement'),
                                description: Core.Definition.getDefinition('EX: 100px ou 40%'),
                                value: ''
                            },
                            {
                                id: 'logoLoadingAnimationClass',
                                type: 'text',
                                label: Core.Definition.getDefinition('Style sur le logo de chargement'),
                                description: Core.Definition.getDefinition('Par défaut: blinker'),
                                value: 'blinker'
                            }
                        ]
                    },
                    login: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Logo'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logo'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoWidth'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Arrière-plan'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bgImage'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bgColorOverlay'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Couleur'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'primaryBGColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'primaryTextColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'primaryBorderColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'secondaryBGColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'secondaryTextColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'secondaryBorderColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'loginButtonBGColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'loginButtonTextColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'loginButtonBorderColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'registerButtonBGColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'registerButtonTextColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'registerButtonBorderColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        cards: [

                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'logo',
                                type: 'avatar',
                                label: Core.Definition.getDefinition('Logo'),
                                value: '',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                }
                            },
                            {
                                id: 'logoWidth',
                                type: 'text',
                                label: Core.Definition.getDefinition('Largeur du logo'),
                                description: Core.Definition.getDefinition('EX: 100px ou 40%'),
                                value: ''
                            },
                            {
                                id: 'bgImage',
                                type: 'image',
                                label: Core.Definition.getDefinition('Image arrière-plan'),
                                placeholder: Core.Definition.getDefinition('Téléversez une image d\'arrière plan'),
                                value: []
                            },
                            {
                                id: 'bgColorOverlay',
                                type: Core.Value.typeColor,
                                mode: 'sketch',
                                label: Core.Definition.getDefinition('Superposée à l\'image'),
                                value: {}
                            },
                            {
                                id: 'primaryBGColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Arrière-plan principal'),
                                value: {}
                            },
                            {
                                id: 'primaryTextColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Texte principal'),
                                value: {}
                            },
                            {
                                id: 'primaryBorderColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Contour principal'),
                                value: {}
                            },
                            {
                                id: 'secondaryBGColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Arrière-plan secondaire'),
                                value: {}
                            },
                            {
                                id: 'secondaryTextColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Texte secondaire'),
                                value: {}
                            },
                            {
                                id: 'secondaryBorderColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Contour secondaire'),
                                value: {}
                            },
                            {
                                id: 'loginButtonBGColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Arrière-plan bouton connexion'),
                                value: {}
                            },
                            {
                                id: 'loginButtonTextColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Texte bouton connexion'),
                                value: {}
                            },
                            {
                                id: 'loginButtonBorderColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Contour bouton connexion'),
                                value: {}
                            },
                            {
                                id: 'registerButtonBGColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Arrière-plan bouton inscription'),
                                value: {}
                            },
                            {
                                id: 'registerButtonTextColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Texte bouton inscription'),
                                value: {}
                            },
                            {
                                id: 'registerButtonBorderColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Contour bouton inscription'),
                                value: {}
                            }
                        ]
                    }
                }
            }
        },
        computed: {
        },
        methods: {
            onRequestSuccess(data) {
            },
            onInvoicePreviewClick() {

            },
            onRequestSuccessLoginPreview(data){

            }
        }
    }
</script>
